<template>
  <div class="meeting-list-item" @click="handleItemClick">
    <div class="meeting-header">
      <h3 class="meeting-title">{{ meeting.name }}</h3>
      <div style="font-size: 12px;color: #DD0000;">{{ getStatusText(meeting.status) }}</div>
    </div>
    <div class="meeting-info">
      <div class="info-item">
        <span class="info-label type-blue-bold">预约时间段：</span>
        <span class="info-value type-blue-bold">{{ formatMeetingTime(meeting) }}</span>
      </div>
      <div class="info-item">
        <span class="info-label ">会议类型：</span>
        <span class="info-value ">{{ meeting.meeting_type }} {{ meeting.meeting_format }}</span>
      </div>
    </div>
    <div class="meeting-actions">
      <!-- 会议确认页面的按钮 - 仅当status为pending时可点击 -->
      <template v-if="isConfirmationPage">
        <van-button type="primary" size="small" color="#145294" :disabled="!canConfirm()" @click.stop="handleConfirmAttend">确认参会</van-button>
        <van-button type="primary" size="small" color="#f5222d" :disabled="!canConfirm()" @click.stop="handleCannotAttend">无法参会</van-button>
      </template>

      <!-- 普通页面的按钮 -->
      <template v-else>
        <van-button type="primary" size="small" color="#145294" @click.stop="handleModifyClick"
          v-if="showModify()">修改</van-button>
        <!-- 取消按钮：置灰时仍可点击但提示 -->
        <van-button type="primary" size="small" color="#d9d9d9" @click.stop="handleCancelClick"
         v-if="showCancel()">
          取消
        </van-button>
      </template>
    </div>
  </div>
</template>

<script>
import { showToast } from 'vant';

export default {
  name: 'MeetingListItem',
  props: {
    meeting: {
      type: Object,
      required: true
    },
    isConfirmationPage: {
      type: Boolean,
      default: false
    }
  },
  emits: ['modify', 'cancel', 'click', 'confirm-attend', 'cannot-attend'],
  methods: {
    // 根据状态获取标签类型 - 严格按照用户提供的枚举映射
    getStatusType(status) {
      switch (status) {
        case 'booking':
          return 'warning';
        case 'cannot_attend':
        case 'canceled':
        case 'cancelled':
          return 'danger';
        case 'pending':
          return 'info';
        case 'completed':
          return 'default';
        default:
          return 'default';
      }
    },
    // 根据状态获取标签颜色 - 严格按照用户提供的枚举映射
    getStatusColor(status) {
      switch (status) {
        case 'booking':
          return '#E6A23C'; // 黄色
        case 'cannot_attend':
        case 'canceled':
        case 'cancelled':
          return '#F56C6C'; // 红色
        case 'pending':
          return '#145294'; // 蓝色
        case 'completed':
          return '#909399'; // 灰色
        default:
          return '#909399'; // 灰色
      }
    },
    // 根据状态获取文本 - 严格按照用户提供的枚举映射
    getStatusText(status) {
      switch (status) {
        case 'pending':
          return '邀约中';
        case 'cannot_attend':
          return '无法参会';
        case 'confirmed':
          return this.isConfirmationPage ? '(受邀)待开展' : '待开展';
        case 'completed':
          return '已结束'; // 严格使用枚举中的'completed'
        case 'canceled':
        case 'cancelled':
          return '已取消';
        default:
          return '未知';
      }
    },
    // 格式化会议时间
    formatMeetingTime(meeting) {
      // 处理ISO 8601格式的时间字段（接口返回的标准格式）
      if (meeting.scheduled_time) {
        try {
          const date = new Date(meeting.scheduled_time);
          if (!isNaN(date.getTime())) {
            // 构建完整的时间字符串：YYYY-MM-DD HH:mm（使用UTC时间）
            const timeStr = `${date.getUTCFullYear()}-${(date.getUTCMonth() + 1).toString().padStart(2, '0')}-${date.getUTCDate().toString().padStart(2, '0')} ${date.getUTCHours().toString().padStart(2, '0')}:${date.getUTCMinutes().toString().padStart(2, '0')}`;

            // 如果有结束时间，添加结束时间（使用UTC时间）
            if (meeting.end_time) {
              const endDate = new Date(meeting.end_time);
              if (!isNaN(endDate.getTime())) {
                const endTimeStr = `${endDate.getUTCHours().toString().padStart(2, '0')}:${endDate.getUTCMinutes().toString().padStart(2, '0')}`;
                return `${timeStr} - ${endTimeStr}`;
              }
            }

            return timeStr;
          }
        } catch (error) {
          // 时间格式化错误不需要提示用户，仅内部记录
        }
      }

      // 处理已经格式化好的时间字段（本地存储或其他情况）
      if (meeting.start_time && meeting.end_time) {
        return `${meeting.start_time} - ${meeting.end_time}`;
      }

      // 处理只有开始时间的情况
      if (meeting.start_time) {
        return meeting.start_time;
      }

      return '时间未定';
    },
    // 处理点击事件
    handleItemClick() {
      this.$emit('click', this.meeting);
    },

    // 处理确认参会事件
    handleConfirmAttend() {
      this.$emit('confirm-attend', this.meeting);
    },

    // 处理无法参会事件
    handleCannotAttend() {
      this.$emit('cannot-attend', this.meeting);
    },

    // 处理修改事件
    handleModifyClick() {
      this.$emit('modify', this.meeting);
    },

    // 处理取消点击事件
    handleCancelClick() {
      // 检查会议状态
      console.log('handleCancelClick', this.isNotCancel);
      if (this.isNotCancel()) {
        // 会议已取消，提示用户
        showToast(`会议状态是${this.getStatusText(this.meeting.status)}，无法操作`);
        return;
      }

      const currentUser = JSON.parse(localStorage.getItem('userInfo'));
      // 处理确认页面 && 状态是待处理 && 当前处理人不是会议创建人
      if (this.isConfirmationPage && this.meeting.status === 'pending' && (!currentUser || Number(currentUser.id) !== Number(this.meeting.creator_id))) {
        // 不是当前处理人，提示用户
        showToast(`会议状态是${this.getStatusText(this.meeting.status)}，仅当前处理人可以操作`);
        return;
      }

      // 触发取消事件
      this.$emit('cancel', this.meeting);
    },
    canConfirm() { 
      return this.meeting.status === 'pending';
    },
    // 能否点击取消，根据会议状态
    isNotCancel() {
      return this.meeting.status === 'cancelled' || this.meeting.status === 'canceled' || this.meeting.status === 'completed'
    },
    showCancel(){
      return !this.isConfirmationPage;
    },
    // 是否展示会议按钮
    showModify() {
      // 确认页面不能出现修改按钮
      if (this.isConfirmationPage) {
        return false;
      }
      // 只有创建人可以修改会议
      const currentUser = JSON.parse(localStorage.getItem('userInfo'));
      if (!currentUser || Number(currentUser.id) !== Number(this.meeting.creator_id)) {
        return false;
      }

      // 只有 邀约中、无法参会、确认参会的可以点击修改
      return this.meeting.status === 'pending' || this.meeting.status === 'cannot_attend' || this.meeting.status === 'confirmed'
    },
  }
}
</script>

<style scoped>
.meeting-list-item {
  background-color: #fff;
  border-radius: 8px;
  padding: 4px 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

.meeting-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
}

.meeting-title {
  font-size: 16px;
  font-weight: 1000;
  color: #333;
  margin: 0;
}

.meeting-info {
  background-color: #f5f7fa;
  border-radius: 4px;
  padding: 4px;
  margin-bottom: 4px;
}

.info-item {
  font-size: 14px;
  margin-bottom: 8px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.info-item:last-child {
  margin-bottom: 0;
}

.info-label {
  color: #606266;
}

.info-value {
  color: #303133;
  font-weight: 400;
}

/* 蓝色加粗样式 */
.type-blue-bold {
  color: #145294;
}

.meeting-actions {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-bottom: 2px;
  min-height: 25px; /* 保留行高，确保即使没有按钮也不塌陷 */
}

.meeting-actions .van-button {
  padding-left: 18px;
  padding-right: 18px;
  padding-top: 3px;
  padding-bottom: 3px;
  height: 25px;
}
</style>